import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '../../theme';
const useImage = (imageMobile, imageTablet, imageDesktop) => {
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.up('sm'));
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    if (isTablet && !isDesktop) {
        return imageTablet;
    }
    if (isDesktop) {
        return imageDesktop;
    }
    return imageMobile;
};
export default useImage;
